<template>
    <div class="product-recomended">
        <div class="product-recomended__tabs" v-if="isTablet">
            <div class="recomend-tab"
                v-if="recomendedInfo.min"
                :class="{active: isActiveMiniTab}"
                 @click="setActive('mini')">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.30925 2.30803C1.33325 3.28536 1.33325 4.85603 1.33325 7.9987C1.33325 11.1414 1.33325 12.7127 2.30925 13.6887C3.28659 14.6654 4.85725 14.6654 7.99992 14.6654C11.1426 14.6654 12.7139 14.6654 13.6899 13.6887C14.6666 12.7134 14.6666 11.1414 14.6666 7.9987C14.6666 4.85603 14.6666 3.2847 13.6899 2.30803C12.7146 1.33203 11.1426 1.33203 7.99992 1.33203C4.85725 1.33203 3.28592 1.33203 2.30925 2.30803ZM7.02925 5.01003C7.07451 4.96245 7.10996 4.90642 7.13357 4.84514C7.15718 4.78385 7.16848 4.71852 7.16684 4.65287C7.1652 4.58722 7.15065 4.52254 7.12401 4.46251C7.09737 4.40248 7.05917 4.34829 7.01159 4.30303C6.964 4.25777 6.90797 4.22232 6.84669 4.19871C6.78541 4.17511 6.72008 4.1638 6.65443 4.16544C6.58878 4.16708 6.52409 4.18164 6.46406 4.20828C6.40404 4.23491 6.34985 4.27312 6.30459 4.3207L4.76192 5.9407L4.36192 5.5207C4.31715 5.47122 4.26292 5.4312 4.20244 5.40301C4.14197 5.37481 4.07645 5.35901 4.00977 5.35652C3.94309 5.35404 3.87659 5.36493 3.81418 5.38855C3.75177 5.41217 3.69472 5.44805 3.64639 5.49406C3.59807 5.54007 3.55944 5.5953 3.53279 5.65647C3.50613 5.71764 3.492 5.78354 3.49121 5.85026C3.49042 5.91698 3.50299 5.98319 3.52819 6.04498C3.55338 6.10677 3.59069 6.16289 3.63792 6.21003L4.39992 7.01003C4.44662 7.05904 4.50278 7.09806 4.56501 7.12472C4.62723 7.15138 4.69422 7.16513 4.76192 7.16513C4.82962 7.16513 4.89661 7.15138 4.95883 7.12472C5.02106 7.09806 5.07722 7.05904 5.12392 7.01003L7.02925 5.01003ZM8.66659 5.4987C8.53398 5.4987 8.4068 5.55138 8.31303 5.64514C8.21926 5.73891 8.16659 5.86609 8.16659 5.9987C8.16659 6.13131 8.21926 6.25848 8.31303 6.35225C8.4068 6.44602 8.53398 6.4987 8.66659 6.4987H11.9999C12.1325 6.4987 12.2597 6.44602 12.3535 6.35225C12.4472 6.25848 12.4999 6.13131 12.4999 5.9987C12.4999 5.86609 12.4472 5.73891 12.3535 5.64514C12.2597 5.55138 12.1325 5.4987 11.9999 5.4987H8.66659ZM7.02859 9.6767C7.07581 9.62955 7.11312 9.57343 7.13832 9.51165C7.16351 9.44986 7.17609 9.38365 7.1753 9.31693C7.17451 9.2502 7.16037 9.18431 7.13372 9.12314C7.10706 9.06196 7.06844 9.00674 7.02011 8.96073C6.97178 8.91472 6.91473 8.87884 6.85233 8.85522C6.78992 8.8316 6.72341 8.82071 6.65673 8.82319C6.59005 8.82567 6.52454 8.84148 6.46406 8.86967C6.40358 8.89787 6.34936 8.93789 6.30459 8.98736L4.76192 10.6074L4.36192 10.1874C4.31715 10.1379 4.26292 10.0979 4.20244 10.0697C4.14197 10.0415 4.07645 10.0257 4.00977 10.0232C3.94309 10.0207 3.87659 10.0316 3.81418 10.0552C3.75177 10.0788 3.69472 10.1147 3.64639 10.1607C3.59807 10.2067 3.55944 10.262 3.53279 10.3231C3.50613 10.3843 3.492 10.4502 3.49121 10.5169C3.49042 10.5837 3.50299 10.6499 3.52819 10.7116C3.55338 10.7734 3.59069 10.8296 3.63792 10.8767L4.39992 11.6767C4.44662 11.7257 4.50278 11.7647 4.56501 11.7914C4.62723 11.8181 4.69422 11.8318 4.76192 11.8318C4.82962 11.8318 4.89661 11.8181 4.95883 11.7914C5.02106 11.7647 5.07722 11.7257 5.12392 11.6767L7.02859 9.6767ZM8.66659 10.1654C8.53398 10.1654 8.4068 10.218 8.31303 10.3118C8.21926 10.4056 8.16659 10.5328 8.16659 10.6654C8.16659 10.798 8.21926 10.9252 8.31303 11.0189C8.4068 11.1127 8.53398 11.1654 8.66659 11.1654H11.9999C12.1325 11.1654 12.2597 11.1127 12.3535 11.0189C12.4472 10.9252 12.4999 10.798 12.4999 10.6654C12.4999 10.5328 12.4472 10.4056 12.3535 10.3118C12.2597 10.218 12.1325 10.1654 11.9999 10.1654H8.66659Z" fill="#F6F6F6"/>
                </svg>
                <h3>{{ $t('Minimum configuration', { ns: 'product' }) }}</h3>
            </div>
            <div class="recomend-tab rec"
                v-if="recomendedInfo.rec"
                :class="{active: isActiveRecomTab}"
                 @click="setActive('recom')">
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.98153 2.08229C8.21297 1.68493 8.78703 1.68493 9.01847 2.08229L10.3016 4.28536C10.556 4.72204 10.9822 5.0317 11.4761 5.13865L13.9679 5.67823C14.4173 5.77556 14.5947 6.32151 14.2883 6.66442L12.5896 8.56558C12.2529 8.94242 12.0901 9.44344 12.141 9.94622L12.3978 12.4828C12.4441 12.9403 11.9797 13.2777 11.5589 13.0923L9.22585 12.0642C8.7634 11.8604 8.2366 11.8604 7.77415 12.0642L5.4411 13.0923C5.0203 13.2777 4.55588 12.9403 4.60221 12.4828L4.85903 9.94623C4.90994 9.44344 4.74714 8.94242 4.41043 8.56558L2.7117 6.66442C2.40531 6.32151 2.5827 5.77556 3.03213 5.67823L5.52391 5.13865C6.01781 5.0317 6.44401 4.72205 6.69836 4.28536L7.98153 2.08229Z" fill="#F6F6F6" stroke="#F6F6F6" stroke-width="1.2"/>
                </svg>     
                <h3>{{ $t('Recommended configuration', { ns: 'product' }) }}</h3>               
            </div>
        </div>
        <div class="product-recomended__wrap">
            <div class="product-recomended__block min" v-if="recomendedInfo.min" v-show="isActiveMiniTab">
                <div class="product-recomended__block-title" v-if="!isTablet">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.30925 2.30803C1.33325 3.28536 1.33325 4.85603 1.33325 7.9987C1.33325 11.1414 1.33325 12.7127 2.30925 13.6887C3.28659 14.6654 4.85725 14.6654 7.99992 14.6654C11.1426 14.6654 12.7139 14.6654 13.6899 13.6887C14.6666 12.7134 14.6666 11.1414 14.6666 7.9987C14.6666 4.85603 14.6666 3.2847 13.6899 2.30803C12.7146 1.33203 11.1426 1.33203 7.99992 1.33203C4.85725 1.33203 3.28592 1.33203 2.30925 2.30803ZM7.02925 5.01003C7.07451 4.96245 7.10996 4.90642 7.13357 4.84514C7.15718 4.78385 7.16848 4.71852 7.16684 4.65287C7.1652 4.58722 7.15065 4.52254 7.12401 4.46251C7.09737 4.40248 7.05917 4.34829 7.01159 4.30303C6.964 4.25777 6.90797 4.22232 6.84669 4.19871C6.78541 4.17511 6.72008 4.1638 6.65443 4.16544C6.58878 4.16708 6.52409 4.18164 6.46406 4.20828C6.40404 4.23491 6.34985 4.27312 6.30459 4.3207L4.76192 5.9407L4.36192 5.5207C4.31715 5.47122 4.26292 5.4312 4.20244 5.40301C4.14197 5.37481 4.07645 5.35901 4.00977 5.35652C3.94309 5.35404 3.87659 5.36493 3.81418 5.38855C3.75177 5.41217 3.69472 5.44805 3.64639 5.49406C3.59807 5.54007 3.55944 5.5953 3.53279 5.65647C3.50613 5.71764 3.492 5.78354 3.49121 5.85026C3.49042 5.91698 3.50299 5.98319 3.52819 6.04498C3.55338 6.10677 3.59069 6.16289 3.63792 6.21003L4.39992 7.01003C4.44662 7.05904 4.50278 7.09806 4.56501 7.12472C4.62723 7.15138 4.69422 7.16513 4.76192 7.16513C4.82962 7.16513 4.89661 7.15138 4.95883 7.12472C5.02106 7.09806 5.07722 7.05904 5.12392 7.01003L7.02925 5.01003ZM8.66659 5.4987C8.53398 5.4987 8.4068 5.55138 8.31303 5.64514C8.21926 5.73891 8.16659 5.86609 8.16659 5.9987C8.16659 6.13131 8.21926 6.25848 8.31303 6.35225C8.4068 6.44602 8.53398 6.4987 8.66659 6.4987H11.9999C12.1325 6.4987 12.2597 6.44602 12.3535 6.35225C12.4472 6.25848 12.4999 6.13131 12.4999 5.9987C12.4999 5.86609 12.4472 5.73891 12.3535 5.64514C12.2597 5.55138 12.1325 5.4987 11.9999 5.4987H8.66659ZM7.02859 9.6767C7.07581 9.62955 7.11312 9.57343 7.13832 9.51165C7.16351 9.44986 7.17609 9.38365 7.1753 9.31693C7.17451 9.2502 7.16037 9.18431 7.13372 9.12314C7.10706 9.06196 7.06844 9.00674 7.02011 8.96073C6.97178 8.91472 6.91473 8.87884 6.85233 8.85522C6.78992 8.8316 6.72341 8.82071 6.65673 8.82319C6.59005 8.82567 6.52454 8.84148 6.46406 8.86967C6.40358 8.89787 6.34936 8.93789 6.30459 8.98736L4.76192 10.6074L4.36192 10.1874C4.31715 10.1379 4.26292 10.0979 4.20244 10.0697C4.14197 10.0415 4.07645 10.0257 4.00977 10.0232C3.94309 10.0207 3.87659 10.0316 3.81418 10.0552C3.75177 10.0788 3.69472 10.1147 3.64639 10.1607C3.59807 10.2067 3.55944 10.262 3.53279 10.3231C3.50613 10.3843 3.492 10.4502 3.49121 10.5169C3.49042 10.5837 3.50299 10.6499 3.52819 10.7116C3.55338 10.7734 3.59069 10.8296 3.63792 10.8767L4.39992 11.6767C4.44662 11.7257 4.50278 11.7647 4.56501 11.7914C4.62723 11.8181 4.69422 11.8318 4.76192 11.8318C4.82962 11.8318 4.89661 11.8181 4.95883 11.7914C5.02106 11.7647 5.07722 11.7257 5.12392 11.6767L7.02859 9.6767ZM8.66659 10.1654C8.53398 10.1654 8.4068 10.218 8.31303 10.3118C8.21926 10.4056 8.16659 10.5328 8.16659 10.6654C8.16659 10.798 8.21926 10.9252 8.31303 11.0189C8.4068 11.1127 8.53398 11.1654 8.66659 11.1654H11.9999C12.1325 11.1654 12.2597 11.1127 12.3535 11.0189C12.4472 10.9252 12.4999 10.798 12.4999 10.6654C12.4999 10.5328 12.4472 10.4056 12.3535 10.3118C12.2597 10.218 12.1325 10.1654 11.9999 10.1654H8.66659Z" fill="#F6F6F6"/>
                    </svg>
                    <h3>{{ $t('Minimum configuration', { ns: 'product' }) }}</h3>
                </div>
                <div class="product-recomended__block-body">
                    <div class="product-recomended__block-body-row" v-if="recomendedInfo.min.os">
                        <span class="recomend-title">{{ $t('OS', { ns: 'product' }) }}:</span>
                        <span class="recomend-data">{{recomendedInfo.min.os}}</span>
                    </div>
                    <div class="product-recomended__block-body-row" v-if="recomendedInfo.min.processor">
                        <span class="recomend-title">{{ $t('Processor', { ns: 'product' }) }}:</span>
                        <span class="recomend-data">{{recomendedInfo.min.processor}}</span>
                    </div>
                    <div class="product-recomended__block-body-row" v-if="recomendedInfo.min.memory">
                        <span class="recomend-title">{{ $t('Memory', { ns: 'product' }) }}:</span>
                        <span class="recomend-data">{{recomendedInfo.min.memory}}</span>
                    </div>
                    <div class="product-recomended__block-body-row" v-if="recomendedInfo.min.graphics">
                        <span class="recomend-title">{{ $t('Graphics', { ns: 'product' }) }}:</span>
                        <span class="recomend-data">{{recomendedInfo.min.graphics}}</span>
                    </div>
                    <div class="product-recomended__block-body-row" v-if="recomendedInfo.min.direct_x">
                        <span class="recomend-title">DirectX:</span>
                        <span class="recomend-data">{{recomendedInfo.min.direct_x}}</span>
                    </div>
                    <div class="product-recomended__block-body-row" v-if="recomendedInfo.min.storage">
                        <span class="recomend-title">{{ $t('Storage', { ns: 'product' }) }}:</span>
                        <span class="recomend-data">{{recomendedInfo.min.storage}}</span>
                    </div>
                </div>
            </div>
            <div class="product-recomended__block rec" v-if="recomendedInfo.rec" v-show="isActiveRecomTab">
                <div class="product-recomended__block-title" v-if="!isTablet">
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.98153 2.08229C8.21297 1.68493 8.78703 1.68493 9.01847 2.08229L10.3016 4.28536C10.556 4.72204 10.9822 5.0317 11.4761 5.13865L13.9679 5.67823C14.4173 5.77556 14.5947 6.32151 14.2883 6.66442L12.5896 8.56558C12.2529 8.94242 12.0901 9.44344 12.141 9.94622L12.3978 12.4828C12.4441 12.9403 11.9797 13.2777 11.5589 13.0923L9.22585 12.0642C8.7634 11.8604 8.2366 11.8604 7.77415 12.0642L5.4411 13.0923C5.0203 13.2777 4.55588 12.9403 4.60221 12.4828L4.85903 9.94623C4.90994 9.44344 4.74714 8.94242 4.41043 8.56558L2.7117 6.66442C2.40531 6.32151 2.5827 5.77556 3.03213 5.67823L5.52391 5.13865C6.01781 5.0317 6.44401 4.72205 6.69836 4.28536L7.98153 2.08229Z" fill="#F6F6F6" stroke="#F6F6F6" stroke-width="1.2"/>
                    </svg>                    
                    <h3>{{ $t('Recommended configuration', { ns: 'product' }) }}</h3>
                </div>
                <div class="product-recomended__block-body">
                    <div class="product-recomended__block-body-row" v-if="recomendedInfo.rec.os">
                        <span class="recomend-title">{{ $t('OS', { ns: 'product' }) }}:</span>
                        <span class="recomend-data">{{recomendedInfo.rec.os}}</span>
                    </div>
                    <div class="product-recomended__block-body-row" v-if="recomendedInfo.rec.processor">
                        <span class="recomend-title">{{ $t('Processor', { ns: 'product' }) }}:</span>
                        <span class="recomend-data">{{recomendedInfo.rec.processor}}</span>
                    </div>
                    <div class="product-recomended__block-body-row" v-if="recomendedInfo.rec.memory">
                        <span class="recomend-title">{{ $t('Memory', { ns: 'product' }) }}:</span>
                        <span class="recomend-data">{{recomendedInfo.rec.memory}}</span>
                    </div>
                    <div class="product-recomended__block-body-row" v-if="recomendedInfo.rec.graphics">
                        <span class="recomend-title">{{ $t('Graphics', { ns: 'product' }) }}:</span>
                        <span class="recomend-data">{{recomendedInfo.rec.graphics}}</span>
                    </div>
                    <div class="product-recomended__block-body-row" v-if="recomendedInfo.rec.direct_x">
                        <span class="recomend-title">DirectX:</span>
                        <span class="recomend-data">{{recomendedInfo.rec.direct_x}}</span>
                    </div>
                    <div class="product-recomended__block-body-row" v-if="recomendedInfo.rec.storage">
                        <span class="recomend-title">{{ $t('Storage', { ns: 'product' }) }}:</span>
                        <span class="recomend-data">{{recomendedInfo.rec.storage}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'RecomendedInfo',
    props: {
        recomendedInfo: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            settings: window.settings,
            isActiveMiniTab: true,
            isActiveRecomTab: true,
        };
    },
    computed: {
        isTablet() {
           return window.innerWidth <= 992;
        },
    },
    mounted() {
        if (this.isTablet) {
            this.isActiveRecomTab = false;
        }
    },
    methods: {
        setActive(tabName) {
            if(tabName === 'mini') {
                this.isActiveMiniTab = true
                this.isActiveRecomTab = false
            } else {
                this.isActiveMiniTab = false
                this.isActiveRecomTab = true
            }
        },
    }
};
</script>
<style scoped lang="scss">
    .product-recomended{
        padding: 20px;
        display: flex;
        background-color: #fff;
        border-radius: 8px;
        margin-top: 30px;
        overflow: hidden;
        @media only screen and (max-width: 992px) {
            flex-direction: column;
            background-color: transparent;
            padding: 0;
          }
        &__tabs{
            display: flex;
            background-color: rgba(33, 41, 55, 0.5);
            .recomend-tab{
                color: #C0C3C9;
                font-family: "Avenir-Next", sans-serif;
                font-size: 18px;
                line-height: 25px;
                display: flex;
                align-items: center;
                height: 45px;
                padding: 10px 20px;
                width: 100%;
                transition: 0.4s;
                cursor: pointer;
                svg{
                    margin-right: 10px;
                    transition: 0.4s;
                    width: 24px;
                    height: 24px;
                    path{
                        fill: #C0C3C9;
                    }
                }
                &.rec{
                    svg{
                        path{
                            stroke: #C0C3C9;
                        }
                    }
                }
                &.min{
                    padding-right: 20px;
                    @media only screen and (max-width: 992px) {
                        padding-right: 0;
                    }
                }
                @media only screen and (max-width: 768px) {
                    width: 64px;
                    svg{
                        margin-right: 0;
                    }
                    span,
                    h3{
                        transition: 0.4s;
                        font-size: 0;
                        opacity: 0;
                        white-space: nowrap;
                    }
                }
                &.active{
                    background-color: #212937;
                    border-radius: 8px 8px 0 0;
                    font-family: "Roboto";
                    color: #f6f6f6;
                    &.rec{
                        svg{
                            path{
                                stroke: #f6f6f6;
                            }
                        }
                    }
                    svg{
                        margin-right: 10px;
                        path{
                            fill: #f6f6f6;
                        }
                    }
                    @media only screen and (max-width: 768px) {
                        width: 100%;
                        svg{
                            margin-right: 10px;
                        }
                        span,
                        h3{
                            font-size: 18px;
                            opacity: 1;
                        }
                    }
                }
            }
        }  
        &__wrap{
            background-color: #212937;
            display: flex;
            width: 100%;
        }
        &__block{
            width: 50%;
            &.rec{
                padding-left: 35px;
                border-left: 1px solid #373E4B;
                @media only screen and (max-width: 992px) {
                    padding: 20px 16px;
                    border-left: none;
                }
            }
            @media only screen and (max-width: 992px) {
                padding: 20px 16px;
                width: 100%;
            }
            &-title{
                padding-bottom: 20px;
                display: flex;
                align-items: center;
                &, h3 {
                    color: #F6F6F6;
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    font-size: 16px;
                    line-height: 24px;
                }
                svg{
                    margin-right: 10px;
                }
            }
            &-body{
                &-row{
                    display: flex;
                    padding-bottom: 10px;
                    &:last-child{
                        padding-bottom: 0;
                    }
                    .recomend-title{
                        color: #9BA1AB;
                        font-family: "Avenir-Next", sans-serif;
                        font-size: 16px;
                        line-height: 24px;
                        min-width: 110px;
                        padding-right: 20px;
                    }
                    .recomend-data{
                        color: #F6F6F6;
                        font-family: "Avenir-Next", sans-serif;
                        font-size: 16px;
                        line-height: 24px;
                    }
                }
            }
        }
    }
</style>